var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-list-item",
        { staticClass: "text-center" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                id: _vm.idPrefix + "_MoveupIcon",
                icon: "",
                flat: "",
                depressed: "",
                fab: ""
              },
              on: {
                click: function($event) {
                  return _vm.$emit("MoveUp")
                }
              }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attr = ref.attr
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              _vm._b(
                                { staticClass: "material-icons-round" },
                                "v-icon",
                                attr,
                                false
                              ),
                              on
                            ),
                            [_vm._v("\n            arrow_upward\n          ")]
                          )
                        ]
                      }
                    }
                  ])
                },
                [_vm._v(" "), _c("span", [_vm._v("Move this card up")])]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item",
        { staticClass: "text-center" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                id: _vm.idPrefix + "_MoveDownIcon",
                icon: "",
                flat: "",
                depressed: "",
                fab: ""
              },
              on: {
                click: function($event) {
                  return _vm.$emit("MoveDown")
                }
              }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attr = ref.attr
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              _vm._b(
                                { staticClass: "material-icons-round" },
                                "v-icon",
                                attr,
                                false
                              ),
                              on
                            ),
                            [_vm._v("\n            arrow_downward\n          ")]
                          )
                        ]
                      }
                    }
                  ])
                },
                [_vm._v(" "), _c("span", [_vm._v("Move this card down")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }